(async function (algolia) {
  "use strict";

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { defaultQueryFilter } = algolia.externals.custom;
  const {
    config,
    translations,
    headerTemplate,
    productTemplate,
    footerTemplate,
  } = algolia;

  // Filters for stock policy
  let stockPolicyFilter = "";
  if (["allow", "continue"].includes(algolia.config.stock_policy)) {
    /**
     * For 'allow', we don't need to add any filter as we want to continue
     * displaying all out of stock items.
     */
    stockPolicyFilter = defaultQueryFilter;
  } else if (algolia.config.stock_policy === "deny") {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = "inventory_quantity > 0";
  }

  const index_suffix = await config.index_suffix;
  const isDesktop = window.innerWidth >= 1024;

  // make this global
  function getCheckboxState(id) {
    const checkboxStates =
      JSON.parse(sessionStorage.getItem("checkboxStates")) || {};
    return checkboxStates[id] || false;
  }

  algolia.productsPlugin = {
    getSources({ query, setContext }) {
      // could get this from a template

      const hasSpecialChars = /[!@#$%^*()_=\[\]{};':"\\|,.<>?~`]/.test(
        query
      );

      if (hasSpecialChars) {
        return [];
      }

      const id = window.algoliaShopify.current_collection_id || "";
      const isChecked = getCheckboxState(id);

      const facetFilters = [];

      // Add product_type filter if the checkbox is checked
      if (isChecked) {
        facetFilters.push([`collection_ids:${id}`]);
      }

      return [
        {
          sourceId: "products",
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + "products" + index_suffix,
                  query,
                  params: {
                    hitsPerPage: isDesktop
                      ? 10
                      : config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: `${stockPolicyFilter}`,
                    facetFilters:
                      facetFilters.length > 0 ? facetFilters : "false",
                    distinct: algolia.config.show_products,
                    // optionalFilters: ['meta.custom.manufacturer_type:Genuine']
                  },
                },
              ],
              transformResponse({ results, hits }) {
                setContext({
                  nbProducts: results[0].nbHits,
                  filter: isChecked,
                  id: id,
                });
                return hits;
              },
            });
          },
          templates: {
            // header({ html, state }) {
            //   const resource = translations.products;
            //   return headerTemplate({ html, state }, resource);
            // },
            item({ item, html, components }) {
              const distinct = config.show_products;
              const variantInfo =
                !distinct && item.objectID !== item.id
                  ? `?variant= ${item.objectID}`
                  : "";
              const itemLink = `${window.Shopify.routes.root}products/${item.handle}`;
              const getConversionData = (e, item) => {
                if (!algolia.config.analytics_enabled) return;
                const clickData = {
                  index: item.__autocomplete_indexName,
                  eventName: "Added to cart",
                  queryID: item.__autocomplete_queryID,
                  objectIDs: [item.objectID],
                };

                /**
                 * Uncomment the following function call to start storing data in
                 * local storage for conversion tracking
                 */
                // algolia.saveForConversionTracking(clickData);
              };
              return productTemplate(
                { item, html, components },
                distinct,
                itemLink,
                getConversionData
              );
            },
            footer({ state, html }) {
              const {
                autocomplete_see_all,
                products_autocomplete_hits_per_page,
              } = config;
              const showFooter =
                autocomplete_see_all &&
                state.context.nbProducts > products_autocomplete_hits_per_page;
              return showFooter && footerTemplate({ html, state });
            },
          },
        },
      ];
    },
  };
})(window.algoliaShopify);
